// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__10c9G","question":"Question_question__3niCe","description":"Question_description__MdvW0"};